import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { useEffect, useState } from 'react'
import { loginRequest } from './msalConfig';

const UseMsalLogin = (logUserIn:boolean) => {
  const [msalChecked,setMsalChecked]=useState(false)
    
    const {instance,inProgress,accounts}=useMsal()
    const isAuthenticated = useIsAuthenticated();
    
  useEffect(() => {
    if(logUserIn){
      console.log(logUserIn)

    const login = async () => {
    if(inProgress==='none' && accounts.length===0){   
      try {
        
        await instance.loginPopup(loginRequest); // Use loginPopup for SPA
      } catch (error) {
        console.error(error);
      }
    }
  }
  login();

}else{
  if(isAuthenticated){
    //instance.logout()
  }
}
setMsalChecked(logUserIn===isAuthenticated)

  }, [instance,inProgress,accounts,logUserIn,isAuthenticated]);

  return [msalChecked]

}

export default UseMsalLogin